"use client";

import { useTranslations } from "next-intl";

// Comp
import ProviderCard from "@/components/ProviderCard";
import FilterStatic from "src/components/filter-static";
import IconSprite from "@/components/UI/IconSprite";
import PageHeader from "@/components/layouts/page-header";

// Hooks
import { useProvidersFetch } from "@/domains/providers/hooks/use-providers-fetch";

// Definitions
import type { SelectItemType } from "@/components/select-sorter";
import {
  type FilterParamsType,
  SORT_BASE_KEYS,
  SORT_ORDER_KEYS,
  SORT_PARAM_KEYS,
} from "@/types/filter";

// Utils
import st from "./index.module.scss";

type ProvidersViewType = {
  searchParams: FilterParamsType;
};
export default function ProvidersView(props: ProvidersViewType) {
  const { searchParams } = props;
  const t = useTranslations("ProvidersPage");
  const searchParamsEntries = Object.entries(searchParams);
  const defaultSort = { [SORT_PARAM_KEYS.sortBy]: SORT_BASE_KEYS.popularity };
  const fetchParams = !searchParamsEntries.length ? defaultSort : searchParams;

  searchParams.perPage = 100;
  const { providers } = useProvidersFetch(fetchParams);

  const optionsSort: SelectItemType[] = [
    {
      id: 1,
      value: SORT_BASE_KEYS.popularity,
      label: t("sort.popularity"),
      field: SORT_PARAM_KEYS.sortBy,
      icon: IconSprite({ name: "fire-stroke" }),
    },
    {
      id: 3,
      value: SORT_ORDER_KEYS.desc,
      label: t("sort.a_z"),
      field: SORT_PARAM_KEYS.order,
      icon: IconSprite({ name: "a-z" }),
    },
    {
      id: 2,
      value: SORT_ORDER_KEYS.asc,
      label: t("sort.z_a"),
      field: SORT_PARAM_KEYS.order,
      icon: IconSprite({ name: "z-a" }),
    },
  ];

  return (
    <div className="section">
      <PageHeader title={t("title")} isBackButton />

      <FilterStatic searchParams={searchParams} optionsSort={optionsSort} />
      {providers.length > 0 && (
        <ul className={st.list}>
          {providers.map((item) => {
            return (
              <li className={st.list__item} key={item.slug}>
                <ProviderCard item={item} />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
